<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.sites'), name: 'company_sites' },
            { text: area && area.site.name, name: 'site', params: { site_uuid: $route.params.site_uuid } },
            {
              text: area && area.name,
              name: 'area',
              params: { site_uuid: $route.params.site_uuid, area_uuid: $route.params.area_uuid },
            },
            { text: $t('zones.createZone') },
          ]"
        />
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <ZoneForm v-else :site="area.site" :area="area" @submit="createZone" />
      </div>
    </div>
  </div>
</template>

<script>
import ZoneForm from '@/views/companies/sites/areas/zones/ZoneForm'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import areasApi from '@/api/areas'
import zonesApi from '@/api/zones'

export default {
  name: 'new_zone',
  data: () => ({
    area: null,
    loading: true,
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
    ZoneForm,
  },
  methods: {
    async createZone(zone) {
      const newZone = await zonesApi.create(this.$route.params.area_uuid, zone)
      if (newZone) {
        await this.$router.push(`/company/sites/${this.$route.params.site_uuid}`)
      }
    },
  },
  async created() {
    this.area = await areasApi.get(this.$route.params.site_uuid, this.$route.params.area_uuid)
    this.loading = false
  },
}
</script>
